import React from 'react'
import styles from './styles.css'
import PropTypes from 'prop-types'

export default class KycRadioRectangle extends React.Component {
  static propTypes = {
    value: PropTypes.number,
    onChange: PropTypes.func,
    options: PropTypes.array,
    errorMessage: PropTypes.object,
    disabled: PropTypes.bool,
    fieldName: PropTypes.string,
  }

  onChange(value) {
    this.props.onChange(value)
  }

  renderOptions() {
    const value = this.props.value || ''
    return this.props.options.map((option, key) => {
      const referenceValue = value
      const referenceOptionValue = option.value
      const id = `${referenceOptionValue}-kycradio`
      return (
        <div className={styles.radioContainer} key={key}>
          <input
            className={styles.radioRectangle}
            type="radio"
            id={id}
            name={this.props.fieldName}
            disabled={this.props.disabled}
            checked={referenceValue === referenceOptionValue}
            onChange={() => this.onChange(option.value)}
          />
          <label className={styles.label} htmlFor={id} key={option.label}>
            {option.label}
          </label>
        </div>
      )
    })
  }

  render() {
    return (
      <div>
        <div className={styles.container} style={{ margin: 0 }}>
          {this.renderOptions()}
        </div>
        <div className="os-input-error">{this.props.errorMessage}</div>
      </div>
    )
  }
}
